import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { accountV2Enabled } from '../site-config';
import { AccountV2Service } from './account-v2-service';
import { SessionService } from './session-service';

/**
 * Recently viewed logging (account system v1). Watches router navigations for
 * Registry pages (/plates/REG, and the /plate/ and /plate-detail/ aliases) and upserts
 * a view event for the signed-in user. Logged-in users only; history is
 * private, kept 90 days server side and clearable in full from the account.
 *
 * Off on release hosts: the production API has no recently-viewed endpoint.
 */
@Injectable({ providedIn: 'root' })
export class PlateViewLoggerService {
  private started = false;
  private lastLogged: string | null = null;

  constructor(
    private router: Router,
    private sessionService: SessionService,
    private accountService: AccountV2Service
  ) { }

  public start(): void {
    if (this.started || !accountV2Enabled) return;
    this.started = true;
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const url = e.urlAfterRedirects || e.url;
        const match = url.match(/^\/(?:plates?|plate-detail)\/([^\/?#;]+)/i);
        // Hub slugs under /plates/ (dateless, 26-reg) are not registrations.
        if (!match || !/\d/.test(match[1]) || match[1].includes('-')) return;
        if (!this.sessionService.isLoggedIn()) return;
        const registration = decodeURIComponent(match[1]).replace(/\s+/g, '').toUpperCase();
        if (registration === '' || registration === this.lastLogged) return;
        this.lastLogged = registration;
        this.accountService.recordView(registration).subscribe({
          next: () => { },
          error: () => { }, // view logging must never surface an error to the page
        });
      });
  }
}
